/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DevicePublishInfo } from '../models/device-publish-info';

@Injectable({
  providedIn: 'root',
})
export class DeviceToQueueControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation updateAcknowledgeFlag
   */
  static readonly UpdateAcknowledgeFlagPath = '/api/v1/device/{deviceId}/acknowledge';

  /**
   * Update Acknowledge Flag.
   *
   * The API updates the acknowledge flag to true
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAcknowledgeFlag()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateAcknowledgeFlag$Response(params: {
    deviceId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceToQueueControllerService.UpdateAcknowledgeFlagPath, 'patch');
    if (params) {
      rb.path('deviceId', params.deviceId, {});
    }

    return this.http.request(rb.build({
       responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Update Acknowledge Flag.
   *
   * The API updates the acknowledge flag to true
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAcknowledgeFlag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateAcknowledgeFlag(params: {
    deviceId: string;
  }): Observable<void> {

    return this.updateAcknowledgeFlag$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deviceToQueue
   */
  static readonly DeviceToQueuePath = '/api/v1/deviceToQueue';

  /**
   * Send device info to Queue.
   *
   * The API sends device info to the respective queue when acknowlodge flag is false
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceToQueue()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceToQueue$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceToQueueControllerService.DeviceToQueuePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
       responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Send device info to Queue.
   *
   * The API sends device info to the respective queue when acknowlodge flag is false
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deviceToQueue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceToQueue(params?: {
  }): Observable<void> {

    return this.deviceToQueue$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation adaptorDeviceToQueue
   */
  static readonly AdaptorDeviceToQueuePath = '/api/v1/adaptorDeviceToQueue';

  /**
   * Send Adaptor-Service device info to Queue.
   *
   * The API sends Adaptor services device info to the respective queue
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adaptorDeviceToQueue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adaptorDeviceToQueue$Response(params?: {
    body?: DevicePublishInfo
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DeviceToQueueControllerService.AdaptorDeviceToQueuePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
       responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Send Adaptor-Service device info to Queue.
   *
   * The API sends Adaptor services device info to the respective queue
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `adaptorDeviceToQueue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adaptorDeviceToQueue(params?: {
    body?: DevicePublishInfo
  }): Observable<void> {

    return this.adaptorDeviceToQueue$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
